module.exports = __webpack_public_path__ + "img/ezgif.com-gif-maker-G.ca6bd293.png";